import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// Facebook domain verification
const meta = document.createElement('meta');
meta.name = 'facebook-domain-verification';
meta.content = 'ft3iu8eaj73psctknawc9sne077v6j';
document.head.appendChild(meta);
// Meta Pixel Code
const fbScript = document.createElement('script');
fbScript.innerHTML = `
!function(f,b,e,v,n,t,s)
{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
n.callMethod.apply(n,arguments):n.queue.push(arguments)};
if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
n.queue=[];t=b.createElement(e);t.async=!0;
t.src=v;s=b.getElementsByTagName(e)[0];
s.parentNode.insertBefore(t,s)}(window, document,'script',
'https://connect.facebook.net/en_US/fbevents.js');
fbq('init', '885866990629991');
fbq('track', 'PageView');
`;
document.head.appendChild(fbScript);
// Meta Pixel noscript fallback
const noscript = document.createElement('noscript');
const img = document.createElement('img');
img.height = 1;
img.width = 1;
img.style.display = 'none';
img.src = 'https://www.facebook.com/tr?id=885866990629991&ev=PageView&noscript=1';
noscript.appendChild(img);
document.body.appendChild(noscript);
render(<App data-id="element-283" />, document.getElementById('root'));